import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToSection = () => {
  const location = useLocation();

  useEffect(() => {
    // Map routes to section IDs
    const routeToSection: { [key: string]: string } = {
      '/': 'hero',
      '/about': 'about',
      '/vehicles': 'vehicles',
      '/contact': 'contact',
      '/careers': 'careers',
    };

    const sectionId = routeToSection[location.pathname];

    if (sectionId) {
      // Small delay to ensure content is rendered
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return null;
};

export default ScrollToSection;
